import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { HttpService } from 'src/app/services/http.service';
import { IMyDrpOptions } from 'mydaterangepicker';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { configs } from 'src/app/configs/app.config';

@Component({
  selector: 'app-addgraph',
  templateUrl: './addgraph.component.html',
  styleUrls: ['./addgraph.component.scss']
})
export class AddgraphComponent implements OnInit {

  dropdownList = [];
  selectedItems = [];
  dropdownSettings:IDropdownSettings= {};

  myDateRangePickerOptions: IMyDrpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  public model: any = {
    // beginDate: {  },
    // endDate: { }
  };
  @Input() barLength: any;
  @Input() index: any;
  @Input() cardName: any;
  @Output() graphValue = new EventEmitter();
  @Output() valueChange = new EventEmitter();
  @Input() graphName:any;
  public compareValue:string = 'Compare';
  public compareValueactive:boolean = false;
  // For example initialize to specific date (09.10.2018 - 19.10.2018). It is also possible
  // to set initial date range value using the selDateRange attribute.



  addGraph: FormGroup;

  public networktag: any;
  public location: any;
  public compareapp: any;
  public scoreName: any;
  public networks: any;
  // public stream: boolean;
  public xValue: any;
  public dateRange: any;
  public deviceCategory:string;
  public aggregation:any;
  public timeWindow:any;
  public peers:Array<object>=[];
  public date: Date = new Date();
  public successMessage: string = '';
  public errorMessage: string = "";
  public warningMessage: string = "";
  public value: String = "timeseries";
  public compareValuepram:string = '';
  public showFalse:boolean=true;
  public xValueList:Array<any>= [];
  public aggregationList:Array<any> = [];
  public kpiList: Array<any> = [];
  constructor(private ngxService: NgxUiLoaderService, public globalService: GlobalService, private formBuilder: FormBuilder, private httpService: HttpService, ) {
    if (this.globalService && this.globalService.order_id) {
      this.fetchxValueList();
      this.fetchaggregationList();
 
     }
     else {
       let inter = setInterval(() => {
         if (this.globalService && this.globalService.order_id) {
           clearInterval(inter);
           this.fetchxValueList();
     this.fetchaggregationList();
   }
       }, 100);
     }  
     this.addGraph = this.formBuilder.group({
      networktag: [''],
      networktag_select_name: [''],
      location: [''],
      location_select_name: [''],
      compareapp: [''],
      compareapp_select_name: [''],
      scoreName: ['', Validators.required],
      scoreName_select_name: [''],
      aggregation: [''],
      aggregation_select_name: [''],
      networks: [''],
      networks_select_name: [''],
      deviceCategory:[''],
      deviceCategory_select_name: [''],
      kpiType :[''],
      kpiType_select_name:[''],
      timeWindow:[''],
      timeWindow_select_name:[''],
      xValue: [''],
      xValue_select_name: [''],
      peers:[''],
      peers_select_name:[''],
      locationArray:[],
      timeWindowArray:[],
      deviceCategoryArray:[],
      appsArray:[],
      appVersionArray:[],
      networkArray:[],
      speedArray:[],
      model:[''],
      platformArray:[],
      // stream:[''],
      widgetName:[''],
      selectedItems:[]
    });

  }
  public Default_count=0;
  ngOnInit() {

   
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };
    this.addGraph.get('kpiType').setValue('Index');
  
    this.httpService.createGetRequest(configs['api']['fetchXvalue']+this.globalService.order_id+'?type='+this.globalService.orderType).subscribe((response: any) => {
      this.xValue = this.globalService.toObject('',response);
    },
      (error) => {
        this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] :error && error['error'] && error.error['statusMessage']?error.error['statusMessage']:'';
      })

    
      if(this.cardName=='benchmarking' && this.globalService.orderType=='app'){
        this.httpService.createGetRequest(configs['api']['fetchApp']+ this.globalService.order_id).subscribe((response: any) => {
       
          for(var i=0;i<response.list.length;i++){
             let sel = response.list[i];
             this.Default_count++;
             if((sel)== (this.globalService.selectedOrder['mainApp'])){ 
             break;
             }
          }
          this.peers = this.globalService.toObject("multi-select",response);
          this.selectedItems = [
            { item_id:this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
          }
          ];
        },
          (error) => {
            this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] :error && error['error'] && error.error['statusMessage']?error.error['statusMessage']:'';
          });
        }
        if(this.cardName=='benchmarking' && this.globalService.orderType=='telco'){
          this.httpService.createGetRequest(configs['api']['fetchNetworks']+ this.globalService.order_id).subscribe((response: any) => {
         
            for(var i=0;i<response.list.length;i++){
              let sel = response.list[i];
              this.Default_count++
              if((sel)== (this.globalService.selectedOrder['mainApp'])){
              break;
              }
           }
            this.peers = this.globalService.toObject("multi-select",response);
            this.selectedItems = [
              { item_id: this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
  
            }
            ];
          },
            (error) => {
              this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] :error && error['error'] && error.error['statusMessage']?error.error['statusMessage']:'';
            });
          }
 this.httpService.createGetRequest(configs['api']['fetchAggregation']+this.globalService.order_id).subscribe((response: any) => {
      this.aggregation = this.globalService.toObject('',response);
    },
      (error) => {
        this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] :error && error['error'] && error.error['statusMessage']?error.error['statusMessage']:'';

      })
  }

  public showComapreValue(str,dropValue){
   this.compareValuepram = str;
   this.compareValue = dropValue;
   this.compareValueactive=true;
   this.showFalse = false;
  }
  private fetchxValueList(): void {
    this.httpService.createGetRequest(configs['api']['fetchXvalue']+this.globalService.order_id+'?type='+this.globalService.orderType).subscribe((response: any) => {
        if (response)
        this.xValueList = this.globalService.toObject('', response);
      })
    }
    private fetchaggregationList(): void {
      this.httpService.createGetRequest(configs['api']['fetchAggregation']+this.globalService.order_id).subscribe((response: any) => {
        if (response)
          this.aggregationList = this.globalService.toObject('', response);
      });
    }
    onDeSelect(event){
      if(event){
        if(event['item_text'].toLowerCase() ==this.globalService.selectedOrder['mainApp'].toLowerCase()){
          if(this.Default_count && this.globalService.selectedOrder['mainApp'])
          this.selectedItems = [event,...this.selectedItems];
        }
      }
    }
    onDeSelectAll(event){
          setTimeout(()=>{
          if(this.Default_count && this.globalService.selectedOrder['mainApp']){
                      this.selectedItems = [
            { item_id:this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
          }
          ];
      }
        },100);
    }
  check(arr,ind) {
    for (var i = ind; i < arr.length; i++) {
        if (arr && arr[ind]['graphs'] && 
        arr[ind]['graphs'].length>1) {
          // this.inc_more(ind + 1);
          ind++;
      }
    }
    // if (count == 2) {
    //   this.inc_more(ind + 1);
    // } else {
      this.index = ind;
    // }

  }

  
  ngAfterViewInit() {
    setTimeout(()=>{
      if(this.index>-1){
        let arr=this.globalService.upDatedpageDateArray;
        if(this.cardName=='benchmarking'){
          arr=this.globalService.upDatedpageBenchDateArray;
         }
      this.check(arr,this.index);
    }
    },0);
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';

  }

  public tab1: boolean = true;//for step 3
  public tab2: boolean = true;
  public tab3: boolean = false;
  public showCompareList:boolean=false;
  changeDropdown(str) {
    if (str == "timeseries") {
      this.value = str;
      this.tab1 = true;
      this.tab2 = true;
      this.tab3 = false;
      this.showFalse = true;
      this.compareValueactive = false;
      this.showCompareList=false; 
      this.compareValue='Compare';
       this.addGraph.reset();
       this.selectedItems = [
        { item_id:  this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
      }
      ];
      this.addGraph.get('kpiType').setValue('Index');
      this.addGraph.get('kpiType_select_name').setValue('Index');   
    this.fetchKpiList(this.addGraph['controls']['kpiType']['value']); 
    } else if (str == 'compare') {
      this.value = str;
      this.tab1 = true;
      this.tab3 = true;
      this.tab2 = false;
      this.showFalse = false;
      this.showCompareList = !this.showCompareList;
     this.addGraph.reset();
     this.selectedItems = [
      { item_id:  this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
    }
    ];
    this.addGraph.get('kpiType').setValue('Index');
    this.addGraph.get('kpiType_select_name').setValue('Index');  
    this.fetchKpiList(this.addGraph['controls']['kpiType']['value']);
    } else {
      this.value = str;
      this.tab1 = false;
      this.tab3 = true;
      this.tab2 = false;
      this.compareValueactive = false;
      this.showCompareList=false;
      this.compareValue='Compare';
      this.addGraph.reset();
      this.selectedItems = [
        { item_id:  this.Default_count, item_text: this.globalService.selectedOrder['mainApp']
      }
      ];
      this.addGraph.get('kpiType').setValue('Index');
    this.addGraph.get('kpiType_select_name').setValue('Index');   
    this.fetchKpiList(this.addGraph['controls']['kpiType']['value']);
    }
  }

  clean(obj) {
    var arr = [];
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "//" || obj[propName] === "aN--NaN" || obj[propName] === "NaN--NaN" || obj[propName].length === 0 || obj[propName] === " " || obj[propName] === "select" || obj[propName] === "--Select" || obj[propName] === "Select" || (obj[propName] && obj[propName][0] === "select")) {
        delete obj[propName];
      }
    }
    return obj;
  }
  changeSelection(event) {
    setTimeout(() => {
      let option = event['fieldName'];
      if (option == "scoreName") {
        if (this.value == "timeseries") {
          // this.addGraph.setValue('widgetName', event['name'] + '-' + 'Trend');
          this.addGraph.get('widgetName').setValue(event['name'] + '-' + 'Trend');
        } else if (this.value == 'compare') {
          // this.addGraph.setValue('widgetName', event['name'] + '-' + 'x-axis');
          this.addGraph.get('widgetName').setValue(event['name'] + '-' + 'x-axis');

        } else {
          this.addGraph.get('widgetName').setValue(event['name'] + '-' + 'Distribution');

          // this.addGraph.setValue('widgetName', event['name'] + '-' + 'Distribution');
        }
      }
      
    }, 0);
    
    setTimeout(() => {
    let option = event['fieldName'];
    this.addGraph.controls[option].setValue(event['id']);
    if(event['fieldName']=='kpiType'){
      this.addGraph.controls[option].setValue(event['id']);
      this.addGraph.get('scoreName').setValue('');
      this.addGraph.get('scoreName_select_name').setValue('');   
      this.fetchKpiList(this.addGraph['controls']['kpiType']['value']);
    }
    },0);
  }
  public fetchKpiList(val): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id+'?raw='+val).subscribe((response: any) => {
      if (response) 
        this.kpiList = this.globalService.toObject('', response);
        // this.kpiList = this.kpiList.slice();
    });
  }
  changeDateFormat(object) {
    return (('' + object['day']).length == 1 ? '0' + object['day'] : object['day']) + '-' + (('' + object['month']).length == 1 ? this.globalService.monthchange(+('0' + object['month'])) : this.globalService.monthchange(+object['month'])) + '-' + object['year'];
  }
  submitData($event) {
    let obj = {
      "type": this.globalService.orderType ,
      "scoreName": this.addGraph.value['scoreName'],
      "mainApp": this.globalService.selectedOrder['mainApp'] ,
      "appName": this.addGraph['controls']['appsArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['appsArray']['value']) : undefined,
      "speed": this.addGraph['controls']['speedArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['speedArray']['value']) : undefined,
      "location": this.addGraph['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['locationArray']['value']) : undefined,
      "xValue": this.addGraph.value['xValue'] ? this.addGraph.value['xValue'] : "",
      "telco": this.addGraph['controls']['networkArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['networkArray']['value']) : undefined,
      "timeWindow":  this.addGraph['controls']['timeWindowArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['timeWindowArray']['value']) : undefined,
      "deviceCategory":this.addGraph['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['deviceCategoryArray']['value']) : undefined,
      "pageTab": this.index,
      // "videoStreamType": this.addGraph['controls']['stream']['value'] ? this.addGraph['controls']['stream']['value'] : undefined,
      "widgetName":this.addGraph['controls']['widgetName']['value'],
      "aggregation": this.addGraph.value['aggregation'] ? this.addGraph.value['aggregation'] : '',
      "pageName":this.graphName[this.index]?this.graphName[this.index]:'page' + +(+(this.index)+1),
      // "startDate": this.model.beginDate ? this.changeDateFormat(this.model.beginDate) : '',
      // "endDate": this.model.endDate ? this.changeDateFormat(this.model.endDate) : '',

      "startDate": this.addGraph['controls']['model']['value'] ? this.changeDateFormat(this.addGraph['controls']['model']['value']['beginDate']) : '',
      "endDate": this.addGraph['controls']['model']['value'] ? this.changeDateFormat(this.addGraph['controls']['model']['value']['endDate']) : '',
      "platform":this.addGraph['controls']['platformArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['platformArray']['value']) : undefined,
      "appVersion": this.addGraph['controls']['appVersionArray']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['appVersionArray']['value']) : undefined,
    };
  
    let url = configs['api']['MonitorGraph']+this.value+'/';
    if(this.cardName=='benchmarking'){
     url = configs['api']['GraphBenchmark']+this.value+'/';
     obj["peers"]=this.addGraph['controls']['peers']['value'] ? this.globalService.getDataAsString(this.addGraph['controls']['peers']['value']) : undefined;
     if (this.value == 'compare')
     obj['graphType']=this.compareValuepram;
    }
    if(this.value !='histogram')
    obj['raw']=this.addGraph['controls']['kpiType']?((this.addGraph['controls']['kpiType']['value']=='Index'|| this.addGraph['controls']['kpiType']['value']==false)?false:true):false;
    this.ngxService.start();
    this.httpService.createPostRequest(url, this.clean(obj), this.globalService.order_id).subscribe((response: any) => {
      
      this.ngxService.stop();
      this.successMessage = 'success';
      this.globalService.scrollToTop();
      
      document.body ? document.body.classList.remove('no-scroll') : '';
      setTimeout(() => {
        this.globalService.showPopUp = "";
        this.graphValue.emit(response.list);
      this.valueChange.emit({bool:false,ind:this.index});
      }, 2000)
    },
      (error) => {
        this.ngxService.stop();
         this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] :error && error['error'] && error.error['statusMessage']?error.error['statusMessage']:'';

        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 2000);
        this.globalService.scrollToTop();

      })
  }

}
